import { ChangesDetectContext } from "@via/context/changes-detect-context";
import { useContext } from "react";

export const useChangesDetect = () => useContext(ChangesDetectContext);
